import React from 'react'
import Alert from 'mz-ui-kit/core/Alert'
import { FormattedMessage } from 'mz-intl'
import messages from '../messages.intl'
import { Spacer } from '../elements'
import { isTripCancelled } from 'app/utils/trips'

const CancelledAlert = ({ trip }) => {
  const showCancelledAlert = trip.cancelled ?? isTripCancelled(trip)

  return (
    <div>
      <Spacer />
      {showCancelledAlert && (
        <Alert color="RED">
          <FormattedMessage message={messages.RESERVATION_CANCELLED} />
        </Alert>
      )}
    </div>
  )
}

export default CancelledAlert
